

import React from "react";
import { useCart } from "../pages/CartContext";
import { useNavigate } from "react-router-dom";

const CheckoutPage = () => {
  const { cart, setCart } = useCart();
  const navigate = useNavigate();

  const updateQuantity = (index, delta) => {
    setCart((prev) => {
      const newCart = [...prev];
      const item = { ...newCart[index] };
      item.quantity = Math.max(1, (item.quantity || 1) + delta);
      newCart[index] = item;
      return newCart;
    });
  };

  const removeItem = (index) => {
    setCart((prev) => prev.filter((_, i) => i !== index));
  };

  const subtotal = cart.reduce((acc, item) => {
    const price = parseFloat(item.price.replace(/[^0-9.]/g, ""));
    return acc + price * (item.quantity || 1);
  }, 0);

  const TAX_RATE = 0.0725; // California tax
  const tax = subtotal * TAX_RATE;
  const total = subtotal + tax;

  return (
    <div className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-2 gap-10">
      {/* Bag Section */}
      <div>
        <h2 className="text-2xl font-semibold mb-2">Bag</h2>

        {cart.map((item, i) => (
          <div key={i} className={`pb-4 mb-6 ${i !== cart.length - 1 ? "border-b" : ""}`}>
            <div className="flex justify-between items-center gap-4">
              {/* Image and Remove */}
              <div>
                <img
                  src={item.images[0]}
                  alt={item.name}
                  className="w-24 h-24 object-cover rounded mb-2"
                />
                <button
                  onClick={() => removeItem(i)}
                  className="text-sm underline text-gray-600 hover:text-black"
                >
                  Remove
                </button>
              </div>

              {/* Product Info */}
              <div className="flex-1">
                <p className="font-semibold text-sm">{item.name}</p>
                {/* <p className="text-sm text-gray-500">Size: {item.selectedSize}</p> */}
                  <p className="text-sm text-gray-500">
                    Size: {item.selectedSize} {item.sizeType && `(${item.sizeType})`}
                  </p>
              </div>

              {/* Quantity & Price */}
              <div className="flex items-center gap-4">
                <div className="flex items-center border rounded px-2">
                  <button
                    onClick={() => updateQuantity(i, -1)}
                    className="text-xl px-2"
                  >−</button>
                  <span className="px-2">{item.quantity || 1}</span>
                  <button
                    onClick={() => updateQuantity(i, 1)}
                    className="text-xl px-2"
                  >+</button>
                </div>
                <p className="font-medium">
                  ${(parseFloat(item.price.replace(/[^0-9.]/g, "")) * (item.quantity || 1)).toFixed(2)}
                </p>
              </div>
            </div>
          </div>
        ))}

        {/* Continue Shopping */}
        <div className="mt-4 pt-4 border-t">
          <button
            onClick={() => navigate("/")}
            className="text-sm underline text-gray-600 hover:text-black"
          >
            ← Continue Shopping
          </button>
        </div>
      </div>

      {/* Summary Section */}
      <div className="border rounded-lg p-6">
        <h2 className="text-lg font-semibold mb-4">Summary</h2>
        <div className="flex justify-between mb-2">
          <span>Subtotal</span>
          <span>${subtotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span>Estimated Shipping</span>
          <span>Free</span>
        </div>
        <div className="flex justify-between mb-2">
          <span>Estimated Tax </span>
          <span>${tax.toFixed(2)}</span>
        </div>
        <div className="flex justify-between font-bold text-lg border-t pt-4">
          <span>Total</span>
          <span>${total.toFixed(2)}</span>
        </div>

        {/* <p className="text-xs text-gray-500 mt-4 mb-2">
          You qualify for <strong>Free Shipping</strong> as a Member! Join us or Sign-in
        </p> */}
        <div className="w-full bg-green-600 h-2 rounded mb-4" />

        {/* Checkout Button */}
        <button
          onClick={() => navigate("/payment")}
          className="w-full bg-black text-white py-3 rounded-full font-semibold hover:bg-gray-800"
        >
          Checkout
        </button>

        {/* <button className="w-full border mt-2 py-3 rounded-full font-semibold hover:bg-gray-100">
          PayPal
        </button> */}

        <p className="text-xs text-gray-500 mt-4">
          By selecting one of the above payment options, you confirm that you have read,
          understand, and agree to our Terms of Sale and Privacy Policy.
        </p>
      </div>
    </div>
  );
};

export default CheckoutPage;
